import { PlusInSquareIcon } from "assets/icons";
import { If } from "components";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useState } from "react";
import { Button, Pagination, SearchInput } from "ui";

import {
  DeleteNotificationModal,
  NotificationModal,
  NotificationProductsModal,
  NotificationTable
} from "../../components";
import { useNotificationsList } from "../../hooks";
import { NotificationsListItem } from "../../notifications.types";

import styles from "./Notifications.module.scss";

const Notifications = () => {
  const {
    value: isNotificationModalOpen,
    setTrue: openNotificationModal,
    setFalse: closeNotificationModal
  } = useBoolean(false);

  const [deletingNotificationId, setDeletingNotificationId] = useState<
    string | null
  >(null);

  const [openedNotifications, setOpenedNotification] =
    useState<NotificationsListItem | null>(null);

  const {
    notifications,
    searchValue,
    setSearchValue,
    isLoading,
    sorting,
    page,
    setPage,
    totalItems,
    setSorting,
    refetchNotifications
  } = useNotificationsList();

  return (
    <ContentLayout
      title={t("Notification")}
      action={
        <Button onClick={openNotificationModal} icon={<PlusInSquareIcon />}>
          {t("New Notification")}
        </Button>
      }
    >
      <BoxShadowLayout className={styles.pageContent}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={t("Search...")}
        />

        <NotificationTable
          notificationsList={notifications ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          onDeleteNotification={setDeletingNotificationId}
          onShowProducts={setOpenedNotification}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
          totalItems={totalItems}
        />
      </BoxShadowLayout>

      <If condition={isNotificationModalOpen}>
        <NotificationModal
          isOpen={isNotificationModalOpen}
          onClose={closeNotificationModal}
          refetchNotifications={refetchNotifications}
        />
      </If>

      <If condition={!!deletingNotificationId}>
        <DeleteNotificationModal
          id={String(deletingNotificationId)}
          isOpen={Boolean(deletingNotificationId)}
          onDeleteSuccess={refetchNotifications}
          onClose={() => setDeletingNotificationId(null)}
        />
      </If>

      {openedNotifications && (
        <NotificationProductsModal
          isOpen={Boolean(openedNotifications)}
          onClose={() => setOpenedNotification(null)}
          openedNotification={openedNotifications}
        />
      )}
    </ContentLayout>
  );
};

export default Notifications;
